import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDiamondShine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDiamondShine"><Path d="M11.248 2H12.748V5H11.248V2Z" fill="currentColor"/><Path d="M20.498 3.43934L21.5587 4.5L19.498 6.56066L18.4374 5.5L20.498 3.43934Z" fill="currentColor"/><Path d="M7.3877 7L3.3877 12H20.6086L16.6086 7H7.3877Z" fill="currentColor"/><Path d="M3.43093 13.5L11.9982 22.3269L20.5654 13.5H3.43093Z" fill="currentColor"/><Path d="M5.55882 5.50011L3.49816 3.43945L2.4375 4.50011L4.49816 6.56077L5.55882 5.50011Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDiamondShine;
